import { render, staticRenderFns } from "./CustomPayment.vue?vue&type=template&id=4456f196&scoped=true&"
import script from "./CustomPayment.vue?vue&type=script&lang=js&"
export * from "./CustomPayment.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment.vue?vue&type=style&index=0&id=4456f196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456f196",
  null
  
)

export default component.exports